export const checkSendingMetricsRemovalFilters = (meta, value) => {
  if (meta?.filters) {
    return meta.filters.map((filter) => filter.value).includes(value);
  }

  return meta?.value === value;
};
